export default __webpack_public_path__ + "static/media/fuse-kylo-skewed.c3694b9e.png";